<template>
  <div>
    <mt-header title class="dl_header_white">
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>
    <div class="container" style="padding: 16px">
      <h3 class="dl_font1_color dl_margin1_top">{{ $t("忘记密码？") }}</h3>
      <div :class="{
        'flex dl_font1_color dl_margin1_top': true,
        reverse: signType === 'email',
      }">
        <div class="small" @click="changeType('phone')">
          {{ $t("手机验证") }}
        </div>
        <div class="small" @click="changeType('email')">
          {{ $t("邮箱验证") }}
        </div>
      </div>
      <div v-if="signType === 'phone'" class="area-wrap">
        <div class="area" @click="popupVisible = true">
          +{{ areacode }}
          <img src="../assets/img/login_ico_xia.png" alt />
        </div>
        <mt-field label :placeholder="$t('请填写手机号')" class="dl_margin4_top" v-model="mobileNum">
          <Code @click.native="sendCode" ref="code"></Code>
        </mt-field>
      </div>
      <mt-field v-else label :placeholder="$t('请填写邮箱号')" class="dl_margin4_top" v-model="email">
        <Code @click.native="sendCode" ref="code"></Code>
      </mt-field>
      <div class="dl_line"></div>
      <mt-field label :placeholder="$t('验证码')" class="dl_margin4_top" v-model="code"></mt-field>
      <div class="dl_line"></div>
      <mt-field label :placeholder="$t('设置密码')" class="dl_margin4_top" type="password" v-model="password"></mt-field>
      <div class="dl_line"></div>
      <mt-field label :placeholder="$t('再次输入')" class="dl_margin4_top" type="password" v-model="repassword"></mt-field>
      <div class="dl_line"></div>

      <mt-button type="primary" class="dl_margin4_top" size="large" @click="doReset">{{ $t("确定") }}</mt-button>
    </div>
    <mt-popup v-model="popupVisible" position="bottom">
      <select-area @onChange="onChangeArea" />
    </mt-popup>
    <ImageVerify scene="password_reset" :username="signType == 'phone' ? areacode + '-' + mobileNum : email"
      ref="imageverify" @imageCallback="imageCallback"></ImageVerify>
  </div>
</template>

<script>
import SelectArea from "@/components/SelectArea";
import ImageVerify from "@/components/ImageVerify.vue";
import { validateEmpty, validatePwd } from "@/utils/validate";
import Code from "@/components/Code";
import { Toast } from "mint-ui";
import { httpSendMobileCode, httpResetPassword } from "@/api/login";
export default {
  components: { Toast, Code, SelectArea, ImageVerify },
  name: "Forget",
  data() {
    return {
      mobileNum: "",
      password: "",
      repassword: "",
      code: "",
      popupVisible: false,
      areacode: "852",
      signType: "phone",
      email: "",
    };
  },
  activated() {
    this.password = "";
    this.repassword = "";
    this.code = "";
    this.email = "";
    this.mobileNum = "";
    this.popupVisible = false;
  },
  methods: {
    goback: function () {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    sendCode: function () {

      // this.$refs.imageverify.run()

      // return
      if (validateEmpty(this.mobileNum) && validateEmpty(this.email)) {
        Toast(this.$t("empty"));
        return;
      }

      // 图片验证
      this.$refs.imageverify.run()
    },

    imageCallback() {
      this.$refs.code.run();
    },




    doReset: function () {
      if (
        validateEmpty(this.code) ||
        validateEmpty(this.repassword) ||
        validateEmpty(this.password)
      ) {
        Toast(this.$t("empty"));
        return;
      }
      if (this.password != this.repassword) {
        Toast(this.$t("noequal"));
        return;
      }
      if (!validatePwd(this.password)) {
        Toast(this.$t("wrongpwd"));
        return;
      }
      const p = {
        username:
          this.signType === "phone"
            ? this.areacode + "-" + this.mobileNum
            : this.email,
        password: this.password,
        verification_code: this.code,
      };
      httpResetPassword(p)
        .then((res) => {
          Toast(res.msg);
          this.$router.push("/login");
        })
        .catch(() => { });
    },
    onChangeArea(value) {
      this.popupVisible = false;
      this.areacode = value;
    },
    changeType(type) {
      this.mobileNum = "";
      this.email = "";
      this.signType = type;
    },
  },

};
</script>

<style scoped>
.container {
  padding: 10px;
}

.forget_pass {
  font-size: 14px;
  margin: 25px 0px;
}

a {
  color: #879baa;
  font-weight: 500;
}

/deep/.btn {
  color: #1e86db;
  font-size: 12px;
}

.mint-button--primary {
  background-color: #1e87d9;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  line-height: 1;
  font-size: 14px;
  margin-top: 30px;
  color: #1e87d9;
}

.flex.reverse {
  flex-direction: row-reverse;
}

.flex .small {
  cursor: pointer;
}

.flex .small:first-child,
.flex.reverse .small:last-child {
  font-size: 1.5em;
  font-weight: bold;
  color: #333;
}

.flex.reverse .small:first-child {
  font-size: 1em;
  font-weight: normal;
  color: #1e87d9;
}
</style>
